import { PopUpTypes } from '../entities';

export type PopUpsState = {
  type: PopUpTypes;
};

export const popUpsInitialState: PopUpsState = {
  type: PopUpTypes.NONE,
};
